import {
  Box,
  ButtonBase,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { RandomImageIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/RandomImageIcon";
import { ImageSuiteSample } from "../../../../Helper";
import { ClearIcon } from "../../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ClearIcon";
import { ImprovePromptBtn } from "./ImprovePromptBtn";
import { useLocation } from "react-router-dom";

export const tooltipStyles = {
  tooltip: {
    sx: {
      bgcolor: "var(--M-background103) !important",
      color: "var(--M-background104) !important",
      fontSize: "11px",
      fontWeight: 500,
      padding: "8px 12px",
      borderRadius: "4px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    },
  },
  arrow: {
    sx: {
      color: "var(--M-background103) !important",
    },
  },
};

const ImageAppsType = [
  { appType: 0, type: "image" },
  { appType: 1, type: "logo" },
  { appType: 2, type: "icon" },
  { appType: 3, type: "illustration" },
  { appType: 4, type: "background" },
  { appType: 5, type: "image restore" },
  { appType: 6, type: "micro people" },
  { appType: 7, type: "tiny figure" },
  { appType: 8, type: "image to image" },
];
interface InputTextProps {
  handelGenerateRandomPrompt: () => void;
  IsGeneratePromptLoading: boolean;
  isGenerateImgLoading: boolean;
  setInputValue: (value: string) => void;
  inputValue: string;
  generatedPrompt: string;
  example?: ImageSuiteSample;
  showRandomPromptBtn?: boolean;
  showImprovePromptBtn?: boolean;
  handelImprovePrompt?: () => void;
  isImprovePromptDisabled?: boolean;
}

export const InputText = ({
  handelGenerateRandomPrompt,
  IsGeneratePromptLoading,
  isGenerateImgLoading,
  setInputValue,
  inputValue,
  example,
  generatedPrompt,
  showRandomPromptBtn = true,
  showImprovePromptBtn = true,
  handelImprovePrompt,
  isImprovePromptDisabled,
}: InputTextProps) => {
  const responsiveSize = useMediaQuery("(max-width: 700px)");
  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(event.target.value);
  };

  useEffect(() => {
    if (generatedPrompt?.length > 0) {
      setInputValue("");
      setInputValue(generatedPrompt);
    }
  }, [generatedPrompt]);

  const handleImprovePromptClick = () => {
    if (handelImprovePrompt) {
      handelImprovePrompt();
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        border: "1px solid var(--A-background55)",
        borderRadius: "12px",
        mt: "8px",
        padding: "8px",
      }}
    >
      <div className="input-suite-container">
        <textarea
          value={inputValue ? inputValue : ""}
          onChange={handleInputChange}
          placeholder={example?.prompt}
          className="custom-textarea-suite"
          disabled={IsGeneratePromptLoading || isGenerateImgLoading}
          rows={3}
        />
      </div>
      <Box className="input-failed-actions">
        {inputValue.length > 0 ? (
          <Tooltip
            disableHoverListener={responsiveSize}
            disableFocusListener={responsiveSize}
            disableTouchListener={responsiveSize}
            title="Clear"
            arrow
            placement="top"
            componentsProps={tooltipStyles}
          >
            <ButtonBase
              className="input-failed-clear-text"
              onClick={() => setInputValue("")}
              disabled={
                IsGeneratePromptLoading ||
                isImprovePromptDisabled ||
                isGenerateImgLoading
              }
              sx={{
                opacity:
                  IsGeneratePromptLoading ||
                  isImprovePromptDisabled ||
                  isGenerateImgLoading
                    ? 0.5
                    : 1,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <ClearIcon className="clear-input-icn" />
            </ButtonBase>
          </Tooltip>
        ) : (
          <Box></Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            gap: { xs: "4px", md: "8px" },
            alignItems: "center",
          }}
        >
          {showImprovePromptBtn && (
            <ImprovePromptBtn
              handelImprovePrompt={handleImprovePromptClick}
              isDisabled={
                isImprovePromptDisabled ||
                inputValue?.length === 0 ||
                isGenerateImgLoading ||
                IsGeneratePromptLoading
              }
              inputValue={inputValue}
            />
          )}
          {showRandomPromptBtn && (
            <IconButton
              className="input-failed-improve-text"
              onClick={handelGenerateRandomPrompt}
              disabled={
                IsGeneratePromptLoading ||
                isImprovePromptDisabled ||
                isGenerateImgLoading
              }
              sx={{
                opacity:
                  IsGeneratePromptLoading ||
                  isImprovePromptDisabled ||
                  isGenerateImgLoading
                    ? 0.5
                    : 1,
                cursor: "pointer",

                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <RandomImageIcon className="pro-plan-icon suites" />
              <Typography sx={{ color: "#12b6ea" }}>Inspire me</Typography>
            </IconButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};
